var chunkMapping = {
	"0": [
		4639
	],
	"3": [
		4017,
		4571
	],
	"79": [
		5090
	],
	"164": [
		5177
	],
	"165": [
		5178
	],
	"168": [
		5181
	],
	"169": [
		5182
	],
	"170": [
		5183
	],
	"171": [
		5184
	],
	"172": [
		5185
	],
	"173": [
		5186
	],
	"174": [
		5187
	],
	"175": [
		5188
	],
	"176": [
		5189
	],
	"177": [
		5190
	],
	"178": [
		5191
	],
	"179": [
		5192
	],
	"180": [
		5193
	],
	"181": [
		5194
	],
	"182": [
		5195
	],
	"183": [
		5196
	],
	"184": [
		5197
	],
	"185": [
		5198
	],
	"186": [
		5199
	],
	"187": [
		5200
	],
	"188": [
		5201
	]
};
var idToExternalAndNameMapping = {
	"4017": [
		"default",
		"./nuorder-components",
		3694
	],
	"4571": [
		"default",
		"./helios-components",
		3694
	],
	"4639": [
		"default",
		"./Containers",
		3603
	],
	"5090": [
		"default",
		"./OrderlessInvoices",
		3603
	],
	"5177": [
		"default",
		"./AsyncEventTracker",
		3603
	],
	"5178": [
		"default",
		"./HostWrapper",
		3603
	],
	"5181": [
		"default",
		"./CheckoutV3",
		3603
	],
	"5182": [
		"default",
		"./CheckoutConfirmation",
		3603
	],
	"5183": [
		"default",
		"./ContactCreditCards",
		3603
	],
	"5184": [
		"default",
		"./AuditDialog",
		3603
	],
	"5185": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3603
	],
	"5186": [
		"default",
		"./InvoiceDialog",
		3603
	],
	"5187": [
		"default",
		"./PaymentDueModal",
		3603
	],
	"5188": [
		"default",
		"./PaymentModal",
		3603
	],
	"5189": [
		"default",
		"./Teams",
		3879
	],
	"5190": [
		"default",
		"./PaymentHistory",
		3603
	],
	"5191": [
		"default",
		"./PaymentConfigurations",
		3603
	],
	"5192": [
		"default",
		"./PaymentPreferences",
		3603
	],
	"5193": [
		"default",
		"./ManagePaymentProcessing",
		3603
	],
	"5194": [
		"default",
		"./MobilePaymentsWrapper",
		3603
	],
	"5195": [
		"default",
		"./PayPage",
		3603
	],
	"5196": [
		"default",
		"./Challenge",
		3603
	],
	"5197": [
		"default",
		"./ManagePaymentMethods",
		3603
	],
	"5198": [
		"default",
		"./LightspeedReports",
		3603
	],
	"5199": [
		"default",
		"./ActivateLightspeedPayments",
		3603
	],
	"5200": [
		"default",
		"./MarketingLandingPage",
		3603
	],
	"5201": [
		"default",
		"./ShippingPromotionsListContainer",
		3603
	]
};
var idToRemoteMap = {
	"4017": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3694
		}
	],
	"4571": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3694
		}
	],
	"4639": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3879
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5199": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5200": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	],
	"5201": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3603
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}